import moment from 'moment-timezone';
import {v4} from 'uuid';
import {BLUEPRINT_TYPE_DATETIME_WITH_QUANTITY} from '~/SignUpSheets/reducers/blueprint/constants';
import {getTime30MinsLater} from './misc';

export const initializeSlot = (blueprintType, slots, defaultValue, copied = false) => {
  const slotId = v4();
  let defaultStart = null;
  let defaultEnd = null;

  if (slots && slots.length > 0 && slots[slots.length - 1].end_time) {
    defaultStart = slots[slots.length - 1].end_time;
    defaultEnd = getTime30MinsLater(defaultStart);
  }

  if (defaultValue) {
    return {
      ...defaultValue,
      // biome-ignore lint/style/useNamingConvention: existing error
      slot_id: slotId,
      key: slotId, // needed for animations
      copied,
    };
  }
  return {
    // biome-ignore lint/style/useNamingConvention: existing error
    slot_id: slotId,
    // biome-ignore lint/style/useNamingConvention: existing error
    start_time: defaultStart,
    // biome-ignore lint/style/useNamingConvention: existing error
    end_time: defaultEnd,
    key: slotId, // needed for animations
    quantity: blueprintType === BLUEPRINT_TYPE_DATETIME_WITH_QUANTITY ? 1 : undefined,
    description: blueprintType === BLUEPRINT_TYPE_DATETIME_WITH_QUANTITY ? '' : undefined,
    copied,
    // biome-ignore lint/style/useNamingConvention: existing error
    pristine_quantity: true,
  };
};

export const duplicateSlot = (
  slot,
  allDaySrc = !!slot.all_day,
  allDayTarget = !!slot.all_day,
  copied = false
) => {
  const slotId = v4();
  return {
    ...slot,
    // biome-ignore lint/style/useNamingConvention: existing error
    start_time: allDayTarget || (allDaySrc && !allDayTarget) ? null : slot.start_time,
    // biome-ignore lint/style/useNamingConvention: existing error
    end_time: allDayTarget || (allDaySrc && !allDayTarget) ? null : slot.end_time,
    // biome-ignore lint/style/useNamingConvention: existing error
    pasted_from_all_day: allDaySrc,
    // biome-ignore lint/style/useNamingConvention: existing error
    slot_id: slotId,
    key: slotId,
    copied,
  };
};

const getDefaultValue = (schema, blueprintType, defaultValue, copied = false) => {
  switch (schema.type) {
    case 'number': {
      return defaultValue || 1;
    }
    case 'date': {
      return defaultValue || null;
    }
    case 'slots': {
      const anHourFromCurrentTime = moment().add(1, 'hours');
      const remainder =
        anHourFromCurrentTime.minute() % 5 === 0
          ? anHourFromCurrentTime.minute() % 5
          : 5 - (anHourFromCurrentTime.minute() % 5);
      const roundedDefaultStart = anHourFromCurrentTime.add(remainder, 'minutes').format('h:mm A');
      return defaultValue?.length > 0
        ? defaultValue.map((v) => initializeSlot(blueprintType, undefined, v, copied))
        : // biome-ignore lint/style/useNamingConvention: existing error
          [initializeSlot(blueprintType, [{end_time: roundedDefaultStart}], undefined, copied)];
    }
    case 'link': {
      // biome-ignore lint/style/useNamingConvention: existing error
      return defaultValue || {url: '', display_text: ''};
    }
    default: {
      return defaultValue || '';
    }
  }
};

export const schemaToJson = (
  schema,
  blueprintType,
  scope,
  defaultValues = {},
  copied = false,
  groupId = null
) => {
  const json = {};
  json.uuid = v4();
  schema
    .filter((s) => s.scope === scope)
    .forEach((s) => {
      json[s.name] = getDefaultValue(s, blueprintType, defaultValues[s.name], copied);
    });
  json.new = true;
  if (schema.some((s) => s.name === 'quantity')) {
    // Schema has quantity; track pristine status of quantity
    json.pristine_quantity = true;
  }
  json.copied = copied;
  json.group = groupId;
  if (blueprintType === BLUEPRINT_TYPE_DATETIME_WITH_QUANTITY) {
    json.all_day = Boolean(defaultValues.all_day) ?? true;
    json.title = defaultValues.title;
    json.date = defaultValues.date ?? moment().add(65, 'minutes').format('YYYY-MM-DD');
    json.description = defaultValues.description;
  }
  return json;
};
